import { AppFontAwesomeIcon, AppRemixIcon } from '@/layout/AppComponents';
import styled from 'styled-components';

export default function CustomStateIcon(props) {
  const {
    icon,
    color,
    type,
    size = 24,
  } = props;

  switch (type) {
    case 'fa':
      return <AppFontAwesomeIcon icon={icon} color={color} size={size} />;
    case 'ri':
      return <AppRemixIcon icon={icon} color={color} filled size={size} />;
    case 'ch':
      return <Character color={color}>{icon}</Character>;
    default:
      return <AppFontAwesomeIcon icon={icon} color={color} size={size} />;
  }
}

const Character = styled.div`
  font-size: 18px;
  font-weight: bold;
  color: ${(props) => props.color};
`;
